import { LocaleType } from './Locale';

const theLocale: LocaleType = {
    locale: 'uk',
    conver: 'en-US',
    alia: 'en',
    region: 'United Kingdom',
    regionText: 'United Kingdom',
    language: 'English',
    languageText: 'English',
    appId: 2,
    acceptLanguage: 'en-UK,en;q=0.9',
};
export default theLocale;
